<template>
  <div>
    <div id="colorbar">
      <div class="colorbar_sub">
        <div v-for="(item, idx) in statuses" :key="idx">
          <v-checkbox
            v-if="idx"
            class="priority"
            readonly="true"
            :label="item"
            :ripple="false"
            :color="colors[idx - 1]"
            v-model="isTrue"
            value="true"
          ></v-checkbox>
          <p v-else class="priority">Job Status:</p>
        </div>
      </div>
    </div>
    <div id="container">
      <ejs-schedule
        ref="scheduleObj"
        height="90vh"
        id="Schedule"
        :selectedDate="selectedDate"
        :eventSettings="eventSettings"
        :showQuickInfo="true"
        :currentView="currentView"
        :dragStop="dragStop"
        :dragStart="dragStart"
        :resizeStart="resizeStart"
        :renderCell="onRenderCell"
        :rowAutoHeight="true"
        :eventRendered="onEventRendered"
        :resizeStop="resizeStop"
        :allowResizing="true"
        :allowAdding="false"
        :allowDeleting="false"
        :editorTemplate="'schedulerEditorTemplate'"
      >
        <!-- :actionBegin="actionBegin" 
      :group="group"
      :resourceHeaderTemplateId="resourceHeaderTemplate"-->
        <template v-slot:schedulerEditorTemplate="{}">
          <table class="custom-event-editor" width="100%" cellpadding="5">
            <tbody>
              <tr>
                <td class="e-textlabel">Job Num</td>
                <td colspan="4">
                  <input
                    class="e-field e-input"
                    readonly
                    type="text"
                    name="JobHead_JobNum"
                  />
                </td>
              </tr>
              <tr>
                <td class="e-textlabel">Job Type</td>
                <td colspan="4">
                  <input
                    class="e-field e-input"
                    readonly
                    type="text"
                    name="JobHead_JobType"
                  />
                </td>
              </tr>
              <tr>
                <td class="e-textlabel">Part Num</td>
                <td colspan="4">
                  <input
                    class="e-field e-input"
                    readonly
                    type="text"
                    name="JobHead_PartNum"
                  />
                </td>
              </tr>
              <tr>
                <td class="e-textlabel">Serial Num</td>
                <td colspan="4">
                  <input
                    class="e-field e-input"
                    readonly
                    type="text"
                    name="Equip_SerialNum"
                  />
                </td>
              </tr>
              <tr>
                <td class="e-textlabel">Start Date</td>
                <td colspan="4">
                  <input
                    class="e-field e-input"
                    readonly
                    type="text"
                    name="StartTime"
                  />
                </td>
              </tr>
              <tr>
                <td class="e-textlabel">Start Hour</td>
                <td colspan="4">
                  <input
                    class="e-field e-input"
                    readonly
                    type="text"
                    name="JobOper_StartHour"
                  />
                </td>
              </tr>
              <tr>
                <td class="e-textlabel">Due Date</td>
                <td colspan="4">
                  <input
                    class="e-field e-input"
                    readonly
                    type="text"
                    name="EndTime"
                  />
                </td>
              </tr>
              <tr>
                <td class="e-textlabel">Due Hour</td>
                <td colspan="4">
                  <input
                    class="e-field e-input"
                    readonly
                    type="text"
                    name="JobHead_DueHour"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </template>
        <e-views>
          <e-view option="Week"></e-view>
          <e-view option="TimelineWeek"></e-view>
          <e-view option="Month"></e-view>
          <e-view option="TimelineMonth"></e-view>
          <e-view option="Agenda">List View</e-view>
        </e-views>
        <!-- <e-resources>
          <e-resource
            :field="field"
            title="resources"
            name="resources"
            :dataSource="resourceDataSource"
            :textField="textField"
            :idField="idField"
          >
          </e-resource>
        </e-resources> -->
      </ejs-schedule>
    </div>
  </div>
</template>
<script
  src="https://kit.fontawesome.com/a076d05399.js"
  crossorigin="anonymous"
></script>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import DecodeJWT from "../DecodeJWT";
import {
  // ScheduleComponent,
  Day,
  Week,
  Month,
  Agenda,
  TimelineMonth,
  Resize,
  DragAndDrop,
  TimelineViews,
  ExcelExport,
  SchedulePlugin,
  MonthAgenda,
  ResourceDirective,
  ResourcesDirective,
} from "@syncfusion/ej2-vue-schedule";
import LICIENSE from "../../utils/LICIENSE";
import { registerLicense } from "@syncfusion/ej2-base";
registerLicense(LICIENSE);
var initialLoad = true;
Vue.use(SchedulePlugin);
var resourceHeaderTemplateVue = Vue.component("resource-headerTemplate", {
  template:
    '<div className="template-wrap"><div class="employee-category"><div><img class="employee-image" :src="getImage" :alt="getImage"/></div><div class="employee-name">' +
    '{{getEmployeeName(data)}}</div><div class="employee-designation">{{getEmployeeDesignation(data)}}</div></div></div>',
  data() {
    return {
      data: {},
    };
  },
});
export default {
  components: {
    "e-resource": ResourceDirective,
    "e-resources": ResourcesDirective,
  },
  watch: {
    getJobListBoard() {
      this.eventSettings = { dataSource: this.getJobListBoard };
    },
  },
  data: function () {
    return {
      isTrue: "true",
      a: undefined,
      b: 1,
      allowMultiple: true,
      views: [
        "Day",
        "Week",
        "Month",
        "Agenda",
        "TimelineWeek",
        "TimelineMonth",
        "ExcelExport",
        "MonthAgenda",
      ],
      textField: "resourceName",
      idField: "resourceID",
      field: "resourceID",
      eventSettings: {
        dataSource: [],
        allowDeleting: false,
        allowAdding: false,
      },
      resourceDataSource: [],
      currentView: "TimelineWeek",
      group: {
        resources: ["resources"],
      },
      statuses: [
        "",
        "Closed",
        "Completed",
        "Scheduled on time",
        "Scheduled late",
        // "Low",
        // "Normal",
        // "Very High",
        // "Very Low",
      ],
      colors: [],
      selectedDate: new Date(),
      cssClass: "excel-export",
      curItem: {},
      resourceHeaderTemplate: function (e) {
        console.log(e);
        return {
          template: resourceHeaderTemplateVue,
        };
      },
    };
  },
  computed: {
    ...mapGetters("Data", ["getJobListBoard"]),
  },
  mounted() {
    let token = localStorage.getItem("token");
    if (token == "" || !token) {
      this.$router.push("/login");
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push("/login");
        localStorage.setItem("token", "");
      } else {
        this.$store.dispatch("Data/getJobListBoard");
        this.generateDistinctColors(2);
      }
    }
  },
  provide: {
    schedule: [
      Day,
      Week,
      Month,
      Agenda,
      TimelineViews,
      TimelineMonth,
      DragAndDrop,
      Resize,
      ExcelExport,
      MonthAgenda,
    ],
  },
  methods: {
    generateDistinctColors(count) {
      if (count <= 0) return;
      const colors = [
        "#9dd482",
        "#15c2f4",
        "#048aa9",
        "#c50001",
        // "#f4ca6d",
        // "#025064",
      ];
      this.colors = colors;
    },
    dragStart(item) {
      this.curItem = item.data;
    },
    resizeStart(item) {
      this.curItem = item.data;
    },
    dragStop(item) {
      this.a = this.$refs.scheduleObj.openEditor(item.data, "Save");
      item.data = this.curItem;
    },
    resizeStop(item) {
      this.a = this.$refs.scheduleObj.openEditor(item.data, "Save");
      item.data = this.curItem;
    },
    onEventRendered: function (args) {
      if (args.data.FSCallhd_OpenCall == false)
        args.element.style.backgroundColor = this.colors[0];
      else if (args.data.JobHead_JobComplete == true)
        args.element.style.backgroundColor = this.colors[1];
      else {
        let today = new Date();
        if (args.data.StartTime <= today && today <= args.data.EndTime)
          args.element.style.backgroundColor = this.colors[2];
        else args.element.style.backgroundColor = this.colors[3];
      }
    },
    onRenderCell: function (args) {
      document.querySelectorAll(".e-tbar-btn-text").forEach(function (span) {
        if (span.textContent.toLowerCase().trim() == "agenda") {
          span.textContent = "List View";
        }
      });
    },
    dataBound(args) {
      console.log(args);
      if (initialLoad) {
        // setTimeout(() => {
        //   document.querySelector('.e-all-day-appointment-section').click();
        // }, 0)
        initialLoad = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-vue-schedule/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-calendars/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-navigations/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-popups/styles/material.css";
// @import "../../../assets/css/standard.scss";
.employee-image {
  width: 45px;
  height: 40px;
  float: left;
  border-radius: 50%;
  margin-right: 10px;
}

#colorbar {
  display: flex;
  height: 10vh;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-end;
}

.colorbar_sub {
  display: flex;
  height: 70%;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-around;
  padding-bottom: 10px;
}

.priority {
  font-size: 12px !important;
  height: auto;
  margin-bottom: 0 !important;
  display: flex;
  margin-right: 15px;
}

.priority .v-label {
  font-size: 12px;
}

::v-deep .priority .v-label {
  font-size: 12px;
  cursor: default !important;
}

.name {
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
}
</style>
